import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import { PreVisitQuestionLabel } from './PreVisitQuestionLabel';
import type { PreVisitQuestionRendererProps } from './preVisitQuestionRendererProps';

export function YesNoRenderer({ question, value, isInvalid, onChange }: PreVisitQuestionRendererProps) {
  const { t } = useTranslation('intake');
  const resolvedValue = typeof value === 'string' ? value : '';

  return (
    <div className="space-y-1.5">
      <PreVisitQuestionLabel question={question} />
      <div
        className={cn(
          'inline-flex w-full sm:w-auto bg-zoooffwhite border rounded-xl p-1 gap-1',
          isInvalid ? 'border-zooerrorborder ring-1 ring-zooerrorborder' : 'border-zooborder'
        )}
      >
        <button
          type="button"
          aria-pressed={resolvedValue === 'true'}
          onClick={function pickYes() {
            onChange('true');
          }}
          className={cn(
            'flex-1 sm:flex-none px-6 py-2.5 rounded-lg text-sm font-bold transition-colors',
            resolvedValue === 'true' ? 'bg-zooprimary text-zoowhite' : 'text-zoomuted'
          )}
        >
          {t('preVisit.yes')}
        </button>
        <button
          type="button"
          aria-pressed={resolvedValue === 'false'}
          onClick={function pickNo() {
            onChange('false');
          }}
          className={cn(
            'flex-1 sm:flex-none px-6 py-2.5 rounded-lg text-sm font-bold transition-colors',
            resolvedValue === 'false' ? 'bg-zooprimary text-zoowhite' : 'text-zoomuted'
          )}
        >
          {t('preVisit.no')}
        </button>
      </div>
    </div>
  );
}
